(() => {
  let observer;
  let frame = 0;
  let searchDock;
  function syncMobileSearch() {
    if(searchDock && !searchDock.anchor.isConnected){searchDock.dock.remove();searchDock=undefined;}
    if(!searchDock){
      const form=document.querySelector('.vr-hero-search'),header=document.querySelector('.section-header .header'),host=header?.closest('.header-wrapper');
      if(!form||!host||!document.body.classList.contains('vr-home-evolution'))return;
      const anchor=document.createElement('span'),dock=document.createElement('div');
      anchor.className='vr-home-search-anchor';anchor.hidden=true;anchor.setAttribute('aria-hidden','true');form.before(anchor);
      dock.className='vr-home-search-dock';dock.hidden=true;host.append(dock);
      searchDock={form,header,anchor,dock,pinned:false,width:window.innerWidth,height:window.innerHeight};
    }
    const state=searchDock,{form,header,anchor,dock}=state;
    const moveForm=(pinned)=>{
      const input=form.querySelector('input[type="search"]'),focused=document.activeElement===input;
      let selection;try{selection=[input.selectionStart,input.selectionEnd];}catch(_){}
      if(pinned){dock.append(form);dock.hidden=false;anchor.hidden=false;}
      else{anchor.before(form);dock.hidden=true;anchor.hidden=true;}
      state.pinned=pinned;document.body.classList.toggle('vr-home-search-pinned',pinned);
      if(focused){input.focus({preventScroll:true});if(selection)try{input.setSelectionRange(...selection);}catch(_){}}
    };
    const mobile=window.matchMedia('(max-width:749px)').matches;
    if(state.pinned && (!mobile||state.width!==window.innerWidth||state.height!==window.innerHeight))moveForm(false);
    state.width=window.innerWidth;state.height=window.innerHeight;
    if(!mobile)return;
    const edge=header.getBoundingClientRect().bottom,source=(state.pinned?anchor:form).getBoundingClientRect();
    if(!state.pinned && source.top<=edge){
      // The placeholder retains the original absolute position, so docking cannot shift the hero.
      const style=getComputedStyle(form);
      for(const key of ['position','top','right','bottom','left','width','height','margin','transform','boxSizing'])anchor.style[key]=style[key];
      moveForm(true);
    }else if(state.pinned && source.top>edge+2)moveForm(false);
  }
  function update() {
    frame = 0;
    const logo = document.querySelector('.vr-home-brand');
    if (!logo) { document.body.classList.remove('vr-home-header-shown'); return; }
    const revealAfter = window.matchMedia('(max-width: 749px)').matches ? 8 : 38;
    // Mobile home: reveal the header as soon as the visitor starts scrolling.
    document.body.classList.toggle('vr-home-header-shown', window.scrollY >= revealAfter);
    syncMobileSearch();
    const hero = logo.closest('.vr-hero'), photo = hero?.querySelector('.vr-hero-picture img');
    if (window.innerWidth >= 750 && photo?.naturalWidth) {
      const area = hero.getBoundingClientRect(), rect = photo.getBoundingClientRect();
      const height = Math.min(rect.width / photo.naturalWidth, rect.height / photo.naturalHeight) * photo.naturalHeight;
      // The wall/floor join is at row 499 in the approved 778px desktop photograph.
      const offset = window.innerWidth >= 990 ? 0 : (rect.height - height) / 2;
      const originalFloor = rect.top + offset + height * (499 / 778) - area.top;
      const lift = window.innerWidth >= 990 ? height * (52 / 778) : 0;
      const floor = originalFloor - lift;
      [hero, hero.parentElement].forEach(node => {
        node?.style.setProperty('--vr-original-floor-line', originalFloor + 'px');
        node?.style.setProperty('--vr-floor-lift', lift + 'px');
      });
      hero.style.setProperty('--vr-floor-line', floor + 'px');
      hero.parentElement?.style.setProperty('--vr-floor-line', floor + 'px');
    }
    if (window.innerWidth < 750 && photo?.naturalWidth) {
      const area = hero.getBoundingClientRect(), rect = photo.getBoundingClientRect();
      const scale = Math.max(rect.width / photo.naturalWidth, rect.height / photo.naturalHeight);
      const imageTop = rect.top + (rect.height - photo.naturalHeight * scale) / 2;
      const tableTop = imageTop + scale * 710 - area.top;
      const headerHeight = document.querySelector(".header")?.getBoundingClientRect().height || 80;
      hero.style.setProperty("--vr-mobile-brand-center-y", ((Math.min(headerHeight, tableTop) + tableTop) / 2) + "px");
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }

  function recoverLegacyMobileItalian() {
    const pageLanguage = document.documentElement.lang.slice(0, 2).toLowerCase();
    const preferredLanguage = (navigator.languages?.[0] || navigator.language || '').slice(0, 2).toLowerCase();
    if (!window.matchMedia('(max-width: 749px)').matches || location.pathname !== '/' || pageLanguage !== 'fr' || preferredLanguage !== 'it') return false;
    const form = document.querySelector('#FooterLanguageForm');
    const field = form?.querySelector('[name="locale_code"]');
    if (!form || !field || !form.querySelector('[data-value="it"]')) return false;
    try {
      if (sessionStorage.getItem('vr-mobile-legacy-fr-reset-v1') === 'done') return false;
      sessionStorage.setItem('vr-mobile-legacy-fr-reset-v1', 'done');
    } catch (_) { return false; }
    field.value = 'it';
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = '/';
    form.requestSubmit();
    return true;
  }

  function init() {
    if (recoverLegacyMobileItalian()) return;
    observer?.disconnect();
    const logo = document.querySelector('.vr-home-brand');
    if (logo) { observer = new ResizeObserver(schedule); observer.observe(logo); const hero = logo.closest('.vr-hero'); if (hero) observer.observe(hero); hero?.querySelector('.vr-hero-picture img')?.addEventListener('load', schedule, {once:true}); }
    update();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
